import { TablePage, AddPage, EditPage, ViewPage } from 'src/views/nacountrycode'
import pathMap from 'src/paths/pathMap'

class NaCountryCodeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.NA_COUNTRY_CODE_LIST_VIEW,
        component: TablePage,
      },
      {
        exact: true,
        path: pathMap.NA_COUNTRY_CODE_ADD_VIEW,
        component: AddPage,
      },
      {
        exact: true,
        path: pathMap.NA_COUNTRY_CODE_EDIT_VIEW,
        component: EditPage,
      },
      {
        exact: true,
        path: pathMap.NA_COUNTRY_CODE_DETAILS_VIEW,
        component: ViewPage,
      },
    ]
  }
}

export default NaCountryCodeRoute
